<template>
    <div v-if="Object.keys(difficultyPerformance).length > 0" class="performance-card">
        <h3>Performance by Difficulty</h3>
        <div class="performance-list">
            <div
                v-for="(perf, difficulty) in difficultyPerformance"
                :key="difficulty"
                class="performance-item"
            >
                <div class="perf-header">
                    <span class="perf-topic">{{ difficulty }}</span>
                    <span class="perf-accuracy">{{ perf.accuracy.toFixed(1) }}%</span>
                </div>
                <div class="perf-details">
                    <span>{{ perf.correct }}/{{ perf.attempts }} correct</span>
                    <span>Avg: {{ perf.average_score.toFixed(2) }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DifficultyPerformance',
    props: {
        difficultyPerformance: {
            type: Object,
            required: true
        }
    }
};
</script>

<style scoped>
.performance-card {
    background: var(--bg-secondary);
    padding: 30px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.6);
    border: 1px solid rgba(var(--accent-rgb), 0.4);
    transition: border-color 0.3s;
}

.performance-card:hover {
    border-color: var(--accent);
}

.performance-card h3 {
    margin: 0 0 20px 0;
    color: var(--text-secondary);
    font-size: 24px;
    letter-spacing: 2px;
}

.performance-list {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.performance-item {
    padding: 20px;
    background: var(--bg-primary);
    border: 1px solid rgba(var(--accent-rgb), 0.4);
    transition: all 0.3s;
}

.performance-item:hover {
    border-color: var(--accent);
    background: var(--bg-secondary);
    transform: translateX(5px);
}

.perf-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.perf-topic {
    color: var(--text-primary);
    font-weight: 600;
    font-size: 18px;
}

.perf-accuracy {
    color: var(--text-secondary);
    font-weight: 700;
    font-size: 24px;
}

.perf-details {
    display: flex;
    gap: 20px;
    color: var(--text-primary);
    font-size: 14px;
    opacity: 0.8;
}
</style>